import { elakay_API } from "../../config";
import { elakayAutoText } from "../pageInside/dataElakay";

// Cart Check-in API (server_elakay elakay_services/cartCheckin.js). Every
// amount it returns is authoritative; the UI never sends a price back as
// trusted data -- only cart line ids and the item total it displayed.
const request = async (path, { token, body }) => {
  let response;
  try {
    response = await fetch(`${elakay_API}${path}`, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(body || {}),
    });
  } catch {
    return { success: false, error: elakayAutoText("h_1e3de5e0358549", "Network error. Please try again."), code: "NETWORK_ERROR" };
  }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    return { success: false, error: data.error || "Request failed.", code: data.code || `HTTP_${response.status}`, details: data.details };
  }
  return data;
};

// Every cart line (rows of the Check-in modal).
export const getCheckinLines = (token) => request("/cart/checkin/lines", { token, body: {} });

// The selected lines, re-priced server-side, ready for the existing Checkout.
// 409 PRICE_CHANGED / CHECKIN_LINES_UNAVAILABLE carry fresh lines in `details`.
export const prepareCheckinCheckout = (token, cartItemIds, expectedItemsCents) =>
  request("/cart/checkin/lines", { token, body: { cartItemIds, expectedItemsCents } });

// After the Checkout succeeded: removes only the paid lines from the cart.
export const completeCheckin = (token, orderId) => request("/cart/checkin/complete", { token, body: { orderId } });
